module.exports = __webpack_public_path__ + "img/LMS-Courses-1.7bed5162.svg";